import { IconJobs, IconProfessionalSeller, useStyletron } from '@olxeu-jobs/ui';
import { FormattedMessage, useFormatIndustry, useFormatMessage } from '~i18n';
import { Logo } from '~features/logo';
import { Link } from '~features/router';
import {
  Title,
  LogoWrapper,
  ParamWrapper,
  ParamContent,
  CardWrapper,
  ContentWrapper,
  VisualContentWrapper,
} from './styled-components';
import { Banner } from './banner';
import type { EmployerCardProps } from './types';

export const EmployerCard = ({
  profile,
  headingLevel,
  onClick,
  publicPath,
  target = '_self',
  compact,
}: EmployerCardProps) => {
  const formatMessage = useFormatMessage();
  const formatIndustry = useFormatIndustry();
  const [css] = useStyletron();
  const { bannerUrl, companyName, logoUrl, industry, counters } = profile ?? {};
  const showLogo = compact || !!logoUrl;

  return (
    <Link
      to={publicPath}
      target={target}
      // eslint-disable-next-line formatjs/no-literal-string-in-jsx
      aria-label={`${companyName} - ${formatMessage({
        id: 'comp.company_profile',
        defaultMessage: 'Company Profile',
      })}`}
      onClick={onClick}
      className={css({
        textDecoration: 'none',
      })}
      data-testid="employer-card"
    >
      <CardWrapper $compact={compact}>
        <VisualContentWrapper $compact={compact}>
          {!compact && <Banner url={bannerUrl} />}
          {showLogo && (
            <LogoWrapper $compact={compact}>
              <Logo companyName={companyName} url={logoUrl} />
            </LogoWrapper>
          )}
        </VisualContentWrapper>
        <ContentWrapper>
          <header>
            <Title $as={`h${headingLevel}` as const} $variant="regular">
              {companyName}
            </Title>
          </header>
          <ParamWrapper>
            <IconJobs size={12} $style={{ flex: '0 0 auto' }} />
            <ParamContent>
              <FormattedMessage
                id="comp.employers.label.industry"
                defaultMessage="Industry: <strong>{industry}</strong>"
                values={{
                  industry: formatIndustry(industry) as string,
                  strong: (chunks: string) => <strong>{chunks}</strong>,
                }}
              />
            </ParamContent>
          </ParamWrapper>
          <ParamWrapper>
            <IconProfessionalSeller size={12} $style={{ flex: '0 0 auto' }} />
            <ParamContent>
              <FormattedMessage
                id="comp.employers.label.ads"
                defaultMessage="<strong>{count}</strong> {count, plural, one {ad} other {ads}}"
                values={{
                  count: counters.ads,
                  strong: (chunks: string) => <strong>{chunks}</strong>,
                }}
              />
            </ParamContent>
          </ParamWrapper>
        </ContentWrapper>
      </CardWrapper>
    </Link>
  );
};
